"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentViewerTranslate = void 0;
var answers_lib_1 = require("@wix/answers-lib");
var componentViewerTranslations = {
    de: {
        'components.informative.tip': 'Tipp',
        'components.informative.note': 'Hinweis',
        'components.informative.warning': 'Warnung',
        'components.informative.important': 'Wichtig',
        'components.step-by-step.step-count': 'Schritt {{step}} von {{totalSteps}} Schritten',
        'anchor-navigation.title': 'In diesem Artikel'
    },
    en: {
        'components.informative.tip': 'Tip',
        'components.informative.note': 'Note',
        'components.informative.warning': 'Warning',
        'components.informative.important': 'Important',
        'components.step-by-step.step-count': 'Step {{step}} of {{totalSteps}}',
        'anchor-navigation.title': 'In This Article'
    },
    es: {
        'components.informative.tip': 'Consejo',
        'components.informative.note': 'Nota',
        'components.informative.warning': 'Advertencia',
        'components.informative.important': 'Importante',
        'components.step-by-step.step-count': 'Paso {{step}} de {{totalSteps}}',
        'anchor-navigation.title': 'En este artículo'
    },
    fr: {
        'components.informative.tip': 'Suggestion ',
        'components.informative.note': 'Remarque ',
        'components.informative.warning': 'Avertissement ',
        'components.informative.important': 'Important ',
        'components.step-by-step.step-count': 'Étape {{step}} sur {{totalSteps}}',
        'anchor-navigation.title': 'Dans cet article'
    },
    hi: {
        'components.informative.tip': 'युक्ति',
        'components.informative.note': 'नोट',
        'components.informative.warning': 'चेतावनी',
        'components.informative.important': 'महत्वपूर्ण',
        'components.step-by-step.step-count': 'Étape {{step}} sur {{totalSteps}} ',
        'anchor-navigation.title': 'इस लेख में',
    },
    it: {
        'components.informative.tip': 'Suggerimento',
        'components.informative.note': 'Nota',
        'components.informative.warning': 'Attenzione',
        'components.informative.important': 'Importante',
        'components.step-by-step.step-count': 'Passaggio {{step}} di {{totalSteps}}',
        'anchor-navigation.title': 'In questo articolo'
    },
    ja: {
        'components.informative.tip': 'ヒント',
        'components.informative.note': '注意',
        'components.informative.warning': '警告',
        'components.informative.important': '重要',
        'components.step-by-step.step-count': 'ステップ {{step}} の {{totalSteps}}',
        'anchor-navigation.title': 'この記事内'
    },
    ko: {
        'components.informative.tip': '도움말',
        'components.informative.note': '참고',
        'components.informative.warning': '주의사항',
        'components.informative.important': '중요!',
        'components.step-by-step.step-count': '{{step}}/{{totalSteps}}단계',
        'anchor-navigation.title': '페이지 메뉴'
    },
    nl: {
        'components.informative.tip': 'Tip',
        'components.informative.note': 'Opmerking',
        'components.informative.warning': 'Waarschuwing',
        'components.informative.important': 'Belangrijk',
        'components.step-by-step.step-count': 'Stap {{step}} van {{totalSteps}}',
        'anchor-navigation.title': 'In dit artikel'
    },
    no: {
        'components.informative.tip': 'Tips',
        'components.informative.note': 'Mer',
        'components.informative.warning': 'Advarsel',
        'components.informative.important': 'Viktig',
        'components.step-by-step.step-count': 'Trinn {{step}} av {totalSteps}}',
        'anchor-navigation.title': 'I denne artikkelen'
    },
    pl: {
        'components.informative.tip': 'Porada',
        'components.informative.note': 'Notatka',
        'components.informative.warning': 'Warning',
        'components.informative.important': 'Ważne',
        'components.step-by-step.step-count': 'Krok {{step}} z {{totalSteps}}',
        'anchor-navigation.title': 'W tym artykule'
    },
    pt: {
        'components.informative.tip': 'Dica',
        'components.informative.note': 'Nota',
        'components.informative.warning': 'Atenção',
        'components.informative.important': 'Importante',
        'components.step-by-step.step-count': 'Passo {{step}} de {{totalSteps}}',
        'anchor-navigation.title': 'Neste artigo'
    },
    ru: {
        'components.informative.tip': 'Совет',
        'components.informative.note': 'Примечание',
        'components.informative.warning': 'Обратите внимание',
        'components.informative.important': 'Важно',
        'components.step-by-step.step-count': 'Шаг {{step}} из {{totalSteps}}',
        'anchor-navigation.title': 'В этой статье'
    },
    sv: {
        'components.informative.tip': 'Tips',
        'components.informative.note': 'Note',
        'components.informative.warning': 'Warning',
        'components.informative.important': 'Viktigt',
        'components.step-by-step.step-count': 'Step {{step}}  of {{totalSteps}}',
        'anchor-navigation.title': 'In this article'
    },
    tr: {
        'components.informative.tip': 'İpucu',
        'components.informative.note': 'Not',
        'components.informative.warning': 'Uyarı',
        'components.informative.important': 'Önemli',
        'components.step-by-step.step-count': 'Adım: {{step}}/{{totalSteps}}',
        'anchor-navigation.title': 'Bu Makalede'
    },
    zh: {
        'components.informative.tip': 'Tip',
        'components.informative.note': 'Note',
        'components.informative.warning': 'Warning',
        'components.informative.important': 'Important',
        'components.step-by-step.step-count': 'Step {{step}} of {{totalSteps}}',
        'anchor-navigation.title': 'In this article'
    },
    ar: {
        'components.informative.tip': 'نصيحة',
        'components.informative.note': 'ملاحظة',
        'components.informative.warning': 'تحذير',
        'components.informative.important': 'مهم',
        'components.step-by-step.step-count': '{{totalSteps}} من {{step}} خطوة',
        'anchor-navigation.title': 'في هذا المقال'
    },
    he: {
        'components.informative.tip': 'המלצה',
        'components.informative.note': 'הערה',
        'components.informative.warning': 'אזהרה',
        'components.informative.important': 'חשוב',
        'components.step-by-step.step-count': '{{totalSteps}} מתוך {{step}} צעד',
        'anchor-navigation.title': 'במאמר זה'
    }
};
// tslint:disable-next-line:max-line-length
exports.componentViewerTranslate = function (locale) { return answers_lib_1.createTranslateFn(function (key) {
    var src = componentViewerTranslations[locale] || componentViewerTranslations.en;
    return src[key];
}); };
//# sourceMappingURL=translations.js.map